import { ITranslationEntry } from '../lang';

export const FR: ITranslationEntry = {
  translations: {
    notifications: 'Notifications',
    markAllAsRead: 'Tout marquer comme lus',
    poweredBy: 'Propulsé par',
    settings: 'Paramètres',
  },
  lang: 'fr',
};
